export const csvExportColumnNamesOverride = {
  actualBilling: 'projectList.billableRevenue',
  actualBillingInProjectCurrency: 'projectList.billableRevenueProjectCurrency',
  actualCost: 'projectList.actualCost',
  actualCostInProjectCurrency: 'projectList.actualCostInProjectCurrency',
  actualHours: 'projectList.actualHours',
  budgetCostInProjectCurrency: 'projectList.budgetCostInProjectCurrency',
  budgetCostUsedPercentage: 'projectList.budgetCostUsedPercentage',
  budgetHours: 'projectList.budgetHours',
  budgetHoursRemaining: 'projectList.budgetRemaining',
  budgetHoursUsed: 'projectList.budgetHoursUsed',
  code: 'projectList.projectCode',
  estimatedBudgetCostRemaining: 'projectList.budgetVsScope',
  estimatedBudgetCostRemainingInProjectCurrency:
    'projectList.budgetVsScopeInProjectCurrency',
  estimatedBudgetHoursRemaining: 'projectList.budgetVsScope',
  estimatedHoursAtCompletion: 'projectList.estimatedAtTaskCompletion',
  estimatedTaskCompletionDate: 'projectList.estimatedTaskCompletionDate',
  finalFaskEndDate: 'projectList.actualTaskCompletionDate',
  initialTaskStartDate: 'projectList.actualTaskStartDate',
  name: 'projectList.project',
  projectManagerReference: 'projectList.projectLeader',
  rolledUpEstimatedRemainingHours: 'projectList.workRemaining',
  scopeHoursCompleted: 'projectList.scopeCompleted',
  status: 'projectList.projectStatus',
  totalEstimateContractInProjectCurrency:
    'projectList.totalContractValueInProjectCurrency',
  totalEstimatedBilling: 'projectList.totalEstimatedBilling',
  totalEstimatedBillingInProjectCurrency:
    'projectList.totalEstimatedBillingInProjectCurrency',
  totalTaskEstimatedAtCompletionCost: 'projectList.estimatedAtTaskCompletion',
  totalTaskEstimatedAtCompletionCostInProjectCurrency:
    'projectList.estimatedAtTaskCompletionInProjectCurrency',
  totalTaskEstimatedAtCompletionHours: 'projectList.estimatedAtTaskCompletion',
  totalTaskHours: 'projectList.taskHours'
};
